import { Text } from 'components/Text'
import styled from 'styled-components'

export const AppointmentsContainer = styled.div`
  margin-top: 50px;
  padding-left: 30px;
  padding-right: 48px;
`

export const AppointmentItemText = styled(Text)`
  margin-left: 16px;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1rem;
`
